/**
 * 用于设置body背景，通常在新页面有背景色时使用
 */

import { useEffect } from 'react';

let index = 0;

export default (color = '#f4f7fc') =>
  useEffect(() => {
    if (!color) {
      return;
    }

    const styleEl = document.createElement('style');

    styleEl.id = `bg-${index++}`;
    styleEl.innerHTML = `html body{background-color:${color}};`;

    document.head.appendChild(styleEl);

    return () => {
      document.head.removeChild(styleEl);
    };
  }, [color]);
